import React from "react";
import Login from "../mainComponents/Login";


class Logincont extends React.Component {
  constructor() {
    super();
    this.state = {er: "", tok: ""};
    this.update = this.update.bind(this);
    this.check = this.check.bind(this);

  }


  check(e) {


    let pass1 = (document.getElementById('password').value);
    let user1 = (document.getElementById('employeeid').value.trim());


    function validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    if (pass1.length < 5 && pass1.length != 0) {
      if (user1.length == 0)
        this.setState({er: "Enter the employee id and Min password length:5"});
      else if (isNaN(user1))
        this.setState({er: "Invalid employee id and Min password length: 5"});
      else
        this.setState({er: "Minimum Password length 5"});
      return false;
    }
    if (isNaN(user1)) {
      this.setState({er: "Invalid Employee ID"});
      return false;
    }
    if (!isNaN(user1)) {
      this.setState({er: ""});
      return true;
    }
    if (user1.length != 0 && pass1.length != 0) {
      this.setState({er: ""});
      return true;
    }


  }


  update(e) {


    let pass1 = (document.getElementById('password').value);
    let user1 = (document.getElementById('employeeid').value.trim());
    if (user1.length == 0 && pass1.length == 0) {
      this.setState({er: "No username or password entered"});
      return;
    }
    let login = {id: user1, password: pass1};
    const error = (() => {
      this.setState({er: "Invalid Username or password entered"});
    });


    //Dispatch action to redux
    if (this.check()) {
      this.setState({loading: true});
      this.props.store(login, error);
    }

  }

  componentDidMount() {
    document.getElementById('employeeid').tabIndex = "1";
    document.getElementById('password').tabIndex = "2";
    document.getElementById('loginx').tabIndex = "3";

  }

  render() {
    return (
      <div><h1>Welcome to Quikr Hrms</h1><Login loading={this.props.loading} update={this.update} er={this.state.er}
                                                check={this.check}/>
      </div>);
  }

}

Logincont.propTypes = {
  store: React.PropTypes.func,
  loading: React.PropTypes.bool.isRequired
};

export default Logincont;




/** WEBPACK FOOTER **
 ** ./src/react/pages/loginpage.js
 **/